var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.38 4H15.62C8.34 4 4 8.34 4 15.62V32.36C4 39.66 8.34 44 15.62 44H32.36C39.64 44 43.98 39.66 43.98 32.38V15.62C44 8.34 39.66 4 32.38 4ZM31.52 31.52C31.4 33.22 31.26 35.34 27.42 35.34H20.58C16.76 35.34 16.6 33.22 16.48 31.52L15.86 23.6C15.82 23.08 16 22.58 16.34 22.2C16.68 21.82 17.18 21.62 17.68 21.62H30.32C30.82 21.62 31.32 21.84 31.66 22.2C32 22.58 32.18 23.08 32.14 23.58L31.52 31.52ZM33.6 19.64C33.56 19.64 33.52 19.64 33.48 19.64C31.4 19.44 29.5 19.3 27.68 19.22C25.24 19.1 22.8 19.06 20.34 19.16C19.14 19.22 17.92 19.3 16.72 19.42L14.54 19.64C14.5 19.64 14.44 19.64 14.4 19.64C13.7 19.64 13.1 19.12 13.04 18.4C12.96 17.66 13.52 16.98 14.26 16.92L16.44 16.7C17.3 16.62 18.14 16.56 19 16.52L19.16 15.58C19.32 14.58 19.62 12.66 22.62 12.66H25.4C28.42 12.66 28.72 14.64 28.86 15.6L29.02 16.56C30.52 16.64 32.06 16.76 33.74 16.92C34.5 17 35.04 17.66 34.98 18.42C34.9 19.12 34.3 19.64 33.6 19.64Z",
    fill: "#CC3535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c83ba1ffc01345fc7d5b983fde0598b5.svg";
export { ForwardRef as ReactComponent };